import { UserRole } from '@modules/core/types';
import { Permissions } from '@modules/permissions/types';

export const MUSC_PRODUCTION = {
  [UserRole.ADMINISTRATOR]: [
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.GENETIC_COUNSELING,
    Permissions.GENETIC_COUNSELING__CREATE,
    Permissions.CAN_VIEW_PHI,
    Permissions.CAMPAIGN_TRACKING,
    Permissions.CDC_TIER1_METRICS,
  ],
  [UserRole.EXECUTIVE]: [
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CDC_TIER1_METRICS,
    Permissions.CAMPAIGN_TRACKING,
  ],
  [UserRole.MEMBER_LIMITED_PHI]: [
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CDC_TIER1_METRICS,
    Permissions.CAMPAIGN_TRACKING,
  ],
  [UserRole.MEMBER]: [
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.GENETIC_COUNSELING,
    Permissions.GENETIC_COUNSELING__CREATE,
    Permissions.CAN_VIEW_PHI,
    Permissions.CAMPAIGN_TRACKING,
    Permissions.CDC_TIER1_METRICS,
  ],
};
